import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { Http, Headers } from '@angular/http';
import { AuthService } from './auth/auth.service';
import { LoginViewModel } from '../models/login-view-model';
import { ResetPassword } from '../models/ResetPassword';
import { ChangePassword } from '../models/ChangePassword';
import { ClientRegister } from '../models/ClientRegister';
import { VendorRegister } from '../models/VendorRegister';
import { Observable } from 'rxjs/Observable';
import { VendorCase } from '../models/VendorCase';
import { User } from '../models/User';

@Injectable()
export class AccountService {

  myHeader: Headers;
  constructor(private http: Http,
    private authHttp: AuthHttp,
    public auth: AuthService) {
    this.myHeader = new Headers();
    this.myHeader.append('Content-Type', 'application/json');
    // To fix IE 11 cache API issue.
    this.myHeader.append('Cache-control', 'no-cache');
    this.myHeader.append('Cache-control', 'no-store');
    this.myHeader.append('Expires', '0');
    this.myHeader.append('Pragma', 'no-cache');
    console.log('account Service Initialized...');
  }

  login(user: LoginViewModel) {
    return this.http.post(`/api/login/login`, user, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('login request has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  loginFallThrough(username: string, password: string) {
    return this.http.get(`/api/login/LoginFallThrough?u=` + username + `&p=` + password, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('LoginFallThrough request has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

 getUniversalVerificatonCode(psEmail: string, psLID: string, userGuid: string)  {
    return this.http.get(`/api/login/GetUniversalVerificatonCode?psEmail=` + psEmail + `&psLID=` + psLID + `&userGuid=` + userGuid,
    { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('getUniversalVerificatonCode ' + res.status);
      } else {
        return res.text();
      }
    });
  }

  updateUniversalLogin(psEmail: string, psLID: string) {

    return this.authHttp.post(`/api/login/UpdateuniversalLogin?psEmail=` + psEmail + '&psLID=' + psLID, null,
    { headers: this.myHeader })
    .map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('updateUniversalLogin has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  updateMYJSSICDDAssociation(psEmail: string, psPassword: string, psGUid: string, psLID: string) {

    return this.authHttp.post(`/api/login/updateMYJSSICDDAssociation?psEmail=` + psEmail + '&psLID=' + psLID
       + '&psGUid=' + psGUid + '&psPassword=' + psPassword, null,
    { headers: this.myHeader })
    .map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('updateMYJSSICDDAssociation has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }



  resetPassword(resetPwd: ResetPassword) {
    return this.http.post(`/api/Account/Reset`, resetPwd, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Reset Password has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  changePassword(changePwd: ChangePassword) {
    return this.http.post(`/api/Account/ChangePassword`, changePwd,{ headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Change Password has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  clientRegister(register: ClientRegister) {
    return this.http.post(`/api/Account/ClientRegister`, register, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Client Register has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  async getRecaptchaKey(): Promise<any> {
    return this.http.get(`/api/Account/GetRecaptchaKey`,
      { headers: this.myHeader }).toPromise().then(function (res) {
        console.log(res);
        return res.text();
      });
  }

  async getLiveChatAgentId(): Promise<any> {
    return this.http.get(`/api/Account/GetLiveChatAgentIdConfig`,
      { headers: this.myHeader }).toPromise().then(function (res) {
        console.log(res);
        return res.text();
      });
  }

  async getLiveChatEnvironment(): Promise<any> {
    return this.http.get(`/api/Account/GetLiveChatEnvironmentConfig`,
      { headers: this.myHeader }).toPromise().then(function (res) {
        console.log(res);
        return res.text();
      });
  }

  async getIsAnnualMeetingKey(): Promise<any> {
    return this.http.get(`/api/Account/GetIsAnnualMeetingConfig`,
      { headers: this.myHeader }).toPromise().then(function (res) {
        console.log(res);
        return res.text();
      });
  }

  vendorRegister(register: VendorRegister) {
    return this.http.post(`/api/Account/VendorRegister`, register, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Vendor Register has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  updatePrivacyDate() {
    return this.authHttp.post(`/api/AdminUser/UpdatePrivacyDate`, null, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('updatePrivacyDate has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  async getLoginPageUrls(): Promise<any> {
    return this.http.get(`/api/Account/GetLoginPageUrls`,
      { headers: this.myHeader }).toPromise().then(function (res) {
        return res.json();
      });
  }

  async getForgotPwdUrls(): Promise<any> {
    return this.http.get(`/api/Account/GetForgetPasswordUrls`,
      { headers: this.myHeader }).toPromise().then(function (res) {
        return res.json();
      });
  }

  async getHtmlFile(name: string): Promise<any> {
    return this.http.get('./assets/files/' + name + '.html', { headers: this.myHeader }).toPromise().then(function (res) {
      return res['_body'];
    });
  }


  createVendorCreateRequest(vendorRequest: any) {
    return this.http.post(`/api/Account/CreateVendorCreateRequest`, vendorRequest, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('createVendorCase has failed ' + res.status);
      } else {
        return res.text();
      }
    });
  }

  getCurrencyList() {
    return this.http.get(`/api/Account/GetCurrencyList`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('getCurrencyList request has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }


  allainceLogin(user: LoginViewModel) {
    return this.http.post(`/api/login/AllianceLogin`, user, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('login request has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  allianceLoginFallThrough(username: string, password: string) {
    return this.http.get(`/api/login/AllianceLoginFallThrough?u=` + username + `&p=` + password, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('LoginFallThrough request has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  getCountryList() {
    return this.http.get(`/api/Account/GetCountryList`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {

      } else {
        return res.json();
      }
    });
  }
  isEmailAlreadytExists(psEmail: string) {


    return this.http.get(`/api/account/IsEmailExists?psEmail=` + psEmail, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {

      } else {
        return res.json();
      }
    });
  }


isRegisterUniversalEmailExists(loUser: string, psLID: string) {

  return this.http.get(`/api/account/IsRegisterUniversalEmailExists?psEmail=` + loUser + `&psLID=` + psLID,
       { headers: this.myHeader }).map(res => {
    if (res.status < 200 || res.status > 300) {

    } else {
      return res.json();
    }
  });
}

checkPassword(loUser: string, password: string) {

  return this.http.get(`/api/account/checkPassword?psEmail=` + loUser + `&password=` + password,
       { headers: this.myHeader }).map(res => {
    if (res.status < 200 || res.status > 300) {

    } else {
      return res.json();
    }
  });
}
createAdvisoryLead(advisoryLead: any) {
  return this.http.post(`/api/Account/AdvisoryCreateLead`, advisoryLead, { headers: this.myHeader }).map(res => {
    if (res.status < 200 || res.status > 300) {
      throw new Error('createVendorCase has failed ' + res.status);
    } else {
      return res.json();
    }
  });
}
}




// WEBPACK FOOTER //
// ./src/app/services/account.service.ts